import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import authSlice from "./auth.store";
import immigrationSlice from './immigration.store'
import resumeSlice from "./resume.store";
import notificationSlice from "./notification.store";
import jobSlice from "./resume.store";
import globalDataSlice from "./globalcontents.store";
import chatSlice from "./chat.store";

import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from "redux-persist";

const persistConfig = {
  key: "pelorus",
  storage,
  whitelist: ["authSlice","resumeSlice","jobSlice","immigrationSlice", "notificationSlice","chatSlice"],
};

const combinedReducers = persistReducer(
  persistConfig,
  combineReducers({
    authSlice,
    immigrationSlice,
    resumeSlice,
    jobSlice,
    globalDataSlice,
    notificationSlice,
    chatSlice
  })
);

export const store = configureStore({
  reducer: combinedReducers,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    });
  },
});
export const persistedStore = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
